// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form-contanct-us-wrapper[data-v-44fbca1e]{width:480px}.form-contanct-us-wrapper.is-mobile[data-v-44fbca1e]{width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
